<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { authenticate } from '@/auth'
import { useAppStore } from '@/stores/AppStore'
import LoadingDialog from '@/components/LoadingDialog.vue'
import XpressHeader from './XpressHeader.vue'
import XpressBottomNav from './XpressBottomNav.vue'

const route = useRoute()
const appStore = useAppStore()

const showBottomNav = computed(() => route.meta.showBottomNav !== false)
const showHeader = computed(() => route.meta.showHeader !== false)
const contentHeight = computed(() => {
  let layoutHeight = 0
  if (showHeader.value) layoutHeight += 74
  if (showBottomNav.value) layoutHeight += 70
  return layoutHeight
})

// ตรวจสอบว่ามีข้อมูลผู้ป่วยใน store หรือยัง
const isAuthen = computed(() => !!appStore.patient)

// ตรวจสอบ auth เมื่อเข้าหน้า xpress (ป้องกันการเข้าหน้า xpress โดยยังไม่ได้ทำการ login)
onMounted(() => {
  if (!isAuthen.value) {
    authenticate()
  }
})
</script>

<template>
  <LoadingDialog v-if="!isAuthen" :show="true" />

  <div v-else>
    <!-- Header 74px -->
    <XpressHeader v-if="showHeader" />
    <div :style="{ height: `calc(100vh - ${contentHeight}px)` }" class="tw-overflow-y-auto">
      <router-view />
    </div>
    <!-- Bottom Navigation 71px -->
    <XpressBottomNav v-if="showBottomNav" />
  </div>
</template>
